import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/3d-viewer-virtual-try-on"
    path="business/products/3d-viewer-virtual-try-on"
    element={<AsyncPage />}
  />,
];
